import { Button, ReviewCard, ReviewSummary } from "@pinkyhead/dovekit";
import { Container as PaginationContainer } from "../../../../../hooks/useOnScrollPagination";
import { ReviewLoading } from "../../../../modules/LoadingPlaceholders/ReviewLoading";
import { NoReviews } from "../../../../modules/NoDataPlaceholders/NoReviews";
import { BackButton } from "../../../../common/BackButton";
import { HeaderContainer } from "../../Details.styles";
import { ListContainer } from "./Reviews.styles";
import { useReviews } from "./Reviews.hooks";
import { ReviewContainer } from "../Basic/Basic.styles";

export const Reviews = () => {
  const {
    handleTabChange,
    reviewSummary,
    redirectToCoreProfile,
    handleNextPage,
    reviewsData,
    reviewsIsLoading
  } = useReviews();
  return (
    <div>
      <HeaderContainer>
        <BackButton onClick={() => handleTabChange(0)} />
        <h3>
          All Reviews
        </h3>
      </HeaderContainer>
      <ListContainer>
        <ReviewSummary 
          rating={reviewSummary.rating}
          reviews={reviewSummary.ratingCount}
        />
        <Button
          onClick={redirectToCoreProfile}
          fullWidth
        >
          Review
        </Button>
        <ListContainer className="results">
          {(reviewsIsLoading && reviewsData.length === 0) &&
            <>
              <ReviewLoading />
              <ReviewLoading />
              <ReviewLoading />
            </>
          }
          {reviewsData.length > 0 && 
            <>
              <PaginationContainer onLastElementVisible={handleNextPage}>
                <ListContainer>
                  {reviewsData.map((review: any) => (
                    <ReviewContainer>
                      <ReviewCard 
                        data={{
                          details: review.details,
                          stars: review.stars,
                          reviewedUser: review.reviewedUser
                        }}
                        actions={{ flag: undefined, helpful: undefined }}
                        reviewType="received"
                      />
                    </ReviewContainer>
                  ))}
                </ListContainer>
              </PaginationContainer>
              {reviewsIsLoading &&
                <ReviewLoading />
              }
            </>
          }
          {(reviewsData.lenfth === 0 && !reviewsIsLoading) && <NoReviews />}
        </ListContainer>
      </ListContainer>
    </div>
  )
}
